import React from "react";
import { useParams } from "react-router";
import Retool from ".";
import MainLayout from "layouts/MainLayout";

const CircularAssetPortfolio = () => {
  const reportID = "97552496-0e3a-11f0-9b4d-dff9a3109870";
  const params = useParams();

  const embeddedData = {
    organisation_id: params.organisation_id,
  };

  return (
    <MainLayout
      headerTitle="Assets"
      className="!max-h-[calc(100vh-64px)] overflow-hidden"
    >
      <Retool url={reportID} embeddedData={embeddedData} />
    </MainLayout>
  );
};

export default CircularAssetPortfolio;
